import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

import SogPage from "@/shared/ui/SogPage.vue";
import {onMounted, reactive, ref, watch} from "vue";
import {onBeforeRouteUpdate, useRouter} from "vue-router";
import {useInsuranceStore} from "@/modules/Insurance/store";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import PersonAddressEditComponent from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import apiOrganisationStructure from "@/modules/OrganisationStructure/api";
import {useAccountStore} from "@/stores/accountStore";
import Person from "@/shared/model/person";
import Address from "@/shared/model/Address";
import PersonAddressCardComponent from "@/modules/OrganisationStructure/components/PersonAddressCardComponent.vue";
import SogFlexRow from "@/shared/ui/SogFlexRow.vue";
import copyTo from "@/shared/utils/CopyTo";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import getGuid from "@/shared/utils/getGuid";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogNumericTextBox from "@/shared/ui/SogNumericTextBox.vue";
import SogFormValidationRule from "@/shared/ui/types/SogFormValidationRule";
import SogForm from "@/shared/ui/SogForm.vue";
import PersonAddressForm from "@/modules/OrganisationStructure/components/PersonAddressEditComponent.vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import apiInsurance from "@/modules/Insurance/api";
import {useSpinner} from "@/shared/composables/SogSpinner";
import PersonDetailsId from "@/shared/model/personDetailsId";
import {storeToRefs} from "pinia";



export default /*@__PURE__*/_defineComponent({
  __name: 'EvbActivationPage',
  setup(__props) {

const _root: HTMLElement = document.getElementById("page") as HTMLElement;

const _title = ref("Template")
const _insuranceStore = useInsuranceStore();
const _accountStore = useAccountStore()
const _lst = reactive<{ Person: Person; Address: Address }[]>([])
const _person = reactive<Person>(new Person())
const _address = reactive<Address>(new Address())
const _search = ref("")
const _key = ref("")
const _interval = ref<number | undefined>(undefined)
const _activationDuration = ref(30)
const _durationValidation: SogFormValidationRule[] = [
  {name: 'activationDuration', rules: {required: [true, "1 bis 90 Tage"], min: 1, max: 180}},
]
const _router = useRouter()
const _formActivation = ref<InstanceType<typeof SogForm> | null>(null)
const _personAddressForm = ref<InstanceType<typeof PersonAddressForm> | null>(null)
const _spinner = useSpinner();
const {evbActivationPage: _activationPage} = storeToRefs(_insuranceStore)


async function p_init() {

  const t_default = _accountStore.details?.getNumberValue(PersonDetailsId.EvbActivationDefaultDuration) ?? (_accountStore.isBranch ? 7 : 30)
  const t_max = _accountStore.details?.getNumberValue(PersonDetailsId.EvbActivationMaxDuration) ?? (_accountStore.isBranch ? 30 : _accountStore.isRoot ? 180 : 90)
  _formActivation.value.removeRules("activationDuration")
  _formActivation.value.addRules({
    name: 'activationDuration',
    rules: {required: [true, "1 bis " + t_max + " Tage"], min: 1, max: t_max}
  })

  _activationDuration.value = t_default;

  const count = _activationPage.value.ids.length;
  if (count === 0)
    _router.back()
  _title.value = "eVB Aktivierung"// ("+count+" Versicherungskarte"+((count>1)?"n)":")")

  const lst = await apiOrganisationStructure.listAddress(_accountStore.person?.id ?? "", "activation")
  _lst.length = 0
  if (lst) {
    _lst.push(...lst)
  }
}

onMounted(async () => {
  await p_init()
})

onBeforeRouteUpdate(async () => {
  await p_init()
});

function onClick1(item: { Person: Person; Address: Address }) {
  copyTo(item.Person, _person)
  copyTo(item.Address, _address)
}

watch(_search, () => {
  if (_interval.value) {
    clearInterval(_interval.value)
  }
  _key.value = getGuid();
  if (_search.value.length > 0 && _search.value.length < 3)
    return
  _interval.value = setInterval(async (key: string) => {
    if (_interval.value) {
      clearInterval(_interval.value)
    }
    const lst = await apiOrganisationStructure.listAddress(_accountStore.person?.id ?? "", "activation", _search.value)
    if (key !== _key.value)
      return;
    _lst.length = 0
    if (lst) {
      _lst.push(...lst)
    }
  }, 1000, _key.value)
})

async function onSearch() {
  if (_interval.value) {
    clearInterval(_interval.value)
  }
  const lst = await apiOrganisationStructure.listAddress(_accountStore.person?.id ?? "", "activation", _search.value)
  _lst.length = 0
  if (lst) {
    _lst.push(...lst)
  }
}

function onActivationCancel() {
  _router.back()
}

async function onActivationOk() {
  if (_formActivation.value.validate() && _personAddressForm.value.validate() && _activationPage.value.ids.length > 0) {
    _spinner.show()
    try {
      for (const id of _activationPage.value.ids) {
        const items = await apiInsurance.InsuranceActivate(_person, _address, [id], _activationDuration.value);
        if (!items || items.length === 0)
          return
      }
      _router.back()
    } finally {
      _spinner.hide()
    }
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: _title.value
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogForm, {
                ref_key: "_formActivation",
                ref: _formActivation,
                validations: _durationValidation
              }, {
                default: _withCtx(() => [
                  _createVNode(SogFormField, null, {
                    default: _withCtx(() => [
                      _createVNode(SogNumericTextBox, {
                        modelValue: _activationDuration.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_activationDuration).value = $event)),
                        placeholder: "eVB-Gültigkeit (Tage)",
                        name: "activationDuration",
                        format: "n"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(PersonAddressEditComponent, {
                    ref_key: "_personAddressForm",
                    ref: _personAddressForm,
                    person: _person,
                    address: _address
                  }, null, 8, ["person", "address"])
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          }),
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-check",
                onClick: onActivationOk
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Ok ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cancel",
                onClick: onActivationCancel
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode(" Abbrechen ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SogCard, null, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Wählen Sie einen Kontakt aus ", -1)
            ]))]),
            _: 1
          }),
          _createVNode(SogCardActions, { "is-toolbar": true }, {
            default: _withCtx(() => [
              _createVNode(SogFlexRow, { style: {"justify-content":"flex-start"} }, {
                default: _withCtx(() => [
                  _createVNode(SogTextBox, {
                    modelValue: _search.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_search).value = $event)),
                    placeholder: "Name"
                  }, null, 8, ["modelValue"]),
                  _createVNode(SogCardActionButton, {
                    "mdi-icon": "mdi-magnify",
                    style: {"align-self":"flex-end"},
                    onClick: onSearch
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              _createVNode(SogFlexRow, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_lst, (item) => {
                    return (_openBlock(), _createBlock(PersonAddressCardComponent, {
                      key: item,
                      person: item.Person,
                      address: item.Address,
                      onClick: ($event: any) => (onClick1(item))
                    }, null, 8, ["person", "address", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})